<template>
	<div class="vipTan" v-if="vipTan">
		<div class="vipTan_modal">
			<div class="header_close finger_shape" @click="vipTan = false"></div>
			<div class="PayIcon">
				<img src="../../assets/images/pay_icon.png">
			</div>
			<div class="vip_modal_main">
				{{ content }}
				<div class="vip_modal_main_tip" v-if="!custorm" @click="$windowOpen({ path: '/buy-card/conversion' })">
					已有兑换码，去兑换
				</div>
				<div class="vip_modal_footer">
					<div class="footer_btn finger_shape" @click="vipTan = false">取消</div>
					<div class="footer_btn finger_shape" @click="confirmBtn">确认</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "vipTan",
		props: {
			custorm: {
				type: Boolean,
				default: false,
			},
			title: {
				type: String,
				default: "该功能需要开通凌云卡！",
			},
			content: {
				type: String,
				default: "开通凌云卡解锁全部会员功能",
			},
		},
		data() {
			return {
				vipTan: false,
			};
		},
		mounted() {},
		methods: {
			confirmBtn() {
				this.vipTan = false;
				if (this.custorm) {
					this.$emit("confirmBtn");
				} else {
					this.$windowOpen({
						path: "/buy-card"
					});
				}
			},
			open() {
				this.vipTan = true;
			},
			close() {
				this.vipTan = false;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.vipTan {
		position: fixed;
		top: 0;
		z-index: 999;
		left: 0;
		width: 100vw;
		height: 100vh;

		.vipTan_modal {
			display: flex;
			align-items: center;
			width: 500px;
			background: #FFFFFF;
			box-shadow: 0px 2px 16px 0px rgba(120, 120, 120, 0.5);
			border-radius: 6px;
			border: 1px solid #E2E2E2;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			padding: 48px 26px 40px;

			.header_close {
				position: absolute;
				top: 10px;
				right: 15px;
				width: 28px;
				height: 28px;
				background: url("@/assets/images/close3.png") no-repeat;
				background-size: 100% 100%;
			}

			.PayIcon {
				width: 144px;
				height: 154px;
				margin-right: 15px;

				img {
					display: block;
					width: 144px;
					height: 154px;
				}
			}

			.vip_modal_main {
				width: 280px;
				font-family: SourceHanSansCN, SourceHanSansCN;
				font-weight: 500;
				font-size: 20px;
				color: #333333;
				line-height: 24px;

				.vip_modal_main_tip {
					margin-top: 2px;
					font-size: 14px;
					color: #D70024;
					text-decoration: underline;
					cursor: pointer;
				}
			}

			.vip_modal_footer {
				display: flex;
				padding-top: 30px;
				justify-content: space-between;

				.footer_btn {
					width: 130px;
					height: 38px;
					background: #EEEEEE;
					border-radius: 19px;
					font-size: 16px;
					font-family: Source Han Sans CN-Bold, Source Han Sans CN;
					font-weight: 400;
					color: #3d3d3d;
					display: flex;
					align-items: center;
					justify-content: center;

					&:last-of-type {
						background: #D70024;
						color: #fff;
					}
				}
			}
		}
	}
</style>
